import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import HelpCenterJson from '../shared/help-center.json';
import { PendoService } from 'store/src/lib/pendo/pendo.service';
import { Store } from '@ngrx/store';
import { CommonActions, CommonState } from '@patient-help-center/store';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  helpData = HelpCenterJson;
  userFlag = 'g';
  constructor(
    private pendoService: PendoService,
    private route: ActivatedRoute,
    private commonStore: Store<CommonState>
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params.nav && params.nav === 'r') {
        this.userFlag = 'r';
        this.commonStore.dispatch(
          CommonActions.updateUserFlag({ userFlag: 'r' })
        );
      }
    });
  }

  ngOnInit(): void {
    this.pendoService.setUnknownUser();
  }

  /**
   * Replace dots with slashes in a string.
   * @param str The input string with dots to be replaced.
   * @returns A new string with dots replaced by slashes.
   */
  convertDotToSlash(str: string): string {
    return str.replace(/\./g, '/');
  }
}
